var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-selector-container"},[_c('div',{staticClass:"cell",class:{ active: _vm.value === 0 },on:{"click":function($event){return _vm.onChange(0)}}},[_vm._v("今日")]),_c('div',{staticClass:"cell",class:{ active: _vm.value === 1 },on:{"click":function($event){return _vm.onChange(1)}}},[_vm._v("昨日")])])
}
var staticRenderFns = []

export { render, staticRenderFns }